import type { OrderStatus } from '@/api/orders'

/**
 * Χρώμα ανά κατάσταση παραγγελίας.
 * Η κατάσταση πρέπει να διαβάζεται με μια ματιά, με χρώμα και εικονίδιο (§11).
 */
export const STATUS_TONES: Record<OrderStatus, string> = {
  draft: 'bg-gray-100 text-gray-700 border-gray-300',
  sent: 'bg-blue-50 text-blue-800 border-blue-200',
  received: 'bg-indigo-50 text-indigo-800 border-indigo-200',
  confirmed: 'bg-brand-50 text-brand-800 border-brand-200',
  partially_confirmed: 'bg-amber-50 text-amber-800 border-amber-200',
  delivered: 'bg-green-50 text-green-800 border-green-200',
  cancelled: 'bg-red-50 text-red-800 border-red-200',
}

/** Καταστάσεις από τις οποίες η επιχείρηση μπορεί ακόμη να ακυρώσει. */
export const CANCELLABLE: OrderStatus[] = [
  'draft',
  'sent',
  'received',
  'confirmed',
  'partially_confirmed',
]

export function formatQuantity(value: string): string {
  const number = Number(value)
  return Number.isFinite(number) ? new Intl.NumberFormat('el-GR').format(number) : value
}

export { formatDate, formatDateTime } from '@/lib/format'
